import { Button } from 'antd';
import { TableOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const tableCommand = ({ editor, range }) => {
  const { state } = editor;
  const { from } = state.selection;

  editor.commands.insertContentAt(from, { type: "paragraph" });
  editor.commands.setTextSelection(from);

  return range
    ? editor.chain().focus().deleteRange(range).insertTable({ rows: 3, cols: 2, withHeaderRow: true }).run()
    : editor.chain().focus().insertTable({ rows: 3, cols: 2, withHeaderRow: true }).run();
}

const Table = ({ editor, showLabel = false, indicateActive = true, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${indicateActive && editor.isActive('table') ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<TableOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => tableCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="TABLE" defaultMessage="Table" />
        </div>
      )}
    </Button>
  );
};

export default Table;
